<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 10:58:27
 * @Description: 忘记密码 实人认证（未使用）
-->
<template>
	<div>
		<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
			<a-form-model-item label="姓名">
				<a-input v-model="form.name" />
			</a-form-model-item>
			<a-form-model-item label="证件类型">
				<a-select default-value="1"> <a-select-option value="1">身份证</a-select-option></a-select>
			</a-form-model-item>
			<a-form-model-item label="证件号码">
				<a-input v-model="form.name" />
			</a-form-model-item>
		</a-form-model>

		<div class="next">
			<a-button style="width: 440px" type="primary" @click="() => $emit('next', 3)">
				下一步
			</a-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			labelCol: { span: 6 },
			wrapperCol: { span: 14 },
			form: {
				name: "",
				region: "",
			},
		};
	},
};
</script>

<style lang="less" scoped>
.next {
	text-align: center;
}
</style>
